export default "__VITE_ASSET__CEC4BvNI__"